"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventName = void 0;
var EventName;
(function (EventName) {
    EventName["EECProductClick"] = "EECproductClick";
    EventName["EECProductImpression"] = "EECproductImpression";
    EventName["EECAddToWishlist"] = "EECaddToWishlist";
    EventName["EECRemoveFromWishlist"] = "EECremoveFromWishlist";
    EventName["EECPromotionClick"] = "EECpromotionClick";
    EventName["EECCheckout"] = "EECcheckout";
    EventName["EECPromotionImpression"] = "EECpromotionImpression";
    EventName["EECAddToCart"] = "EECaddToCart";
    EventName["EECRemoveFromCart"] = "EECremoveFromCart";
    EventName["EECProductDetail"] = "EECproductDetail";
    EventName["EECPurchase"] = "EECpurchase";
})(EventName || (exports.EventName = EventName = {}));
//# sourceMappingURL=EventName.js.map